import { CashflowTransactionEntry } from './types';

export const getNewTag = ({
    before,
    after,
}: {
    before: Pick<CashflowTransactionEntry, 'tags'>;
    after: Pick<CashflowTransactionEntry, 'tags'>;
}) => {
    const beforeTagNames = before.tags.map((t) => t.name);
    return after.tags.find((t) => !beforeTagNames.includes(t.name));
};
